const actorTypes = {
    tenant: {},
    owner: {}
};
Object.keys(actorTypes).forEach(key => {
    actorTypes[key].key = key;
});

export default actorTypes;
